import styled from 'styled-components';
import { useState } from 'react';
import { FiSend } from 'react-icons/fi';

const FeedbackContainer = styled.div`
  margin: 1rem auto;
  padding: 1.25rem;
  background: #202a31;
  border-radius: 0.75rem;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);
  max-width: 500px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 1rem;
`;

const FeedbackLabel = styled.span`
  font-size: 1rem;
  color: #00a884;
  font-weight: 600;
`;

const Textarea = styled.textarea`
  width: 100%;
  min-height: 150px; /* Altura mínima aumentada novamente */
  border-radius: 0.5rem; /* Borda similar ao input */
  border: 1px solid #374045; /* Borda dark sutil */
  padding: 0.6rem 0.8rem;
  font-size: 0.95rem;
  resize: vertical;
  background: #2a3942; /* Fundo dark similar ao input */
  color: #e9edef; /* Texto claro */
  transition: border-color 0.2s, box-shadow 0.2s;

  &::placeholder {
    color: #a0b0b8;
  }

  &:focus {
    outline: none;
    border-color: #00a884; /* Manter borda verde ao focar */
    box-shadow: 0 0 0 3px rgba(0, 168, 132, 0.2);
  }
`;

const SubmitBtn = styled.button`
  background: #00a884;
  color: #fff;
  border: none;
  border-radius: 0.75rem;
  padding: 0.6rem 1.5rem;
  font-size: 0.9rem;
  font-weight: 600;
  cursor: pointer;
  align-self: flex-end;
  display: flex;
  align-items: center;
  gap: 0.45rem;
  transition: background 0.2s, transform 0.1s, box-shadow 0.2s;

  &:hover {
    background: #008a6e; /* Verde mais escuro */
    transform: translateY(-2px);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  }

  &:active {
    transform: translateY(0);
    box-shadow: none;
  }

  &:disabled {
    background: #b0c4b1;
    opacity: 0.7;
    cursor: not-allowed;
    transform: none;
    box-shadow: none;
  }
`;

const MAX_LENGTH = 300;

const CharCounter = styled.span`
  align-self: flex-end;
  font-size: 0.75rem;
  color: ${({ exceeded }) => (exceeded ? '#ff4d4f' : '#a0b0b8')};
`;

const IconWrapper = styled.span`
  display: flex;
  align-items: center;
`;

export default function Feedback({ onSubmit }) {
  const [comment, setComment] = useState('');
  const charCount = comment.length;
  const exceeded = charCount > MAX_LENGTH;
  const canSubmit = comment.trim() !== '' && !exceeded;

  return (
    <FeedbackContainer>
      <FeedbackLabel>Deixe seu feedback sobre a Carla:</FeedbackLabel>
      <Textarea
        placeholder="Seu comentário ou sugestão..."
        value={comment}
        maxLength={MAX_LENGTH + 20}
        onChange={(e) => setComment(e.target.value)}
      />
      <CharCounter exceeded={exceeded}>
        {charCount}/{MAX_LENGTH}
      </CharCounter>
      <SubmitBtn
        onClick={() => {
          onSubmit && onSubmit({ comment });
          setComment('');
        }}
        disabled={!canSubmit}
      >
        <IconWrapper>
          <FiSend size={16} />
        </IconWrapper>
        Enviar
      </SubmitBtn>
    </FeedbackContainer>
  );
}
